import React, { useState } from 'react'
import { ArrowClockwise } from 'phosphor-react'

const MACOLA_SCRAP_CODES_URL =
    'https://apps.lyonsinfo.com/Lyons.EAuditor.Prod.Audit.AppLayer/upload/files/Macola_Scrap_Codes.html'

// The file is served without cache headers, so browsers kept showing an old copy after it was updated.
// A new ?v= on every load / Refresh makes the browser fetch the current file.
const freshUrl = () => `${MACOLA_SCRAP_CODES_URL}?v=${Date.now()}`

export const MacolaScrapCodesScreen = () => {
    const [src, setSrc] = useState(freshUrl)

    return (
        <div
            style={{
                width: '100%',
                height: 'calc(100vh - 95px)',
                minHeight: 500,
                background: '#fff',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: '6px 12px',
                    borderBottom: '1px solid #e5e7eb',
                }}
            >
                <button
                    type="button"
                    onClick={() => setSrc(freshUrl())}
                    title="Load the latest scrap codes / Cargar los códigos más recientes"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6,
                        padding: '5px 12px',
                        background: '#fff',
                        border: '1.5px solid #1e3a8a',
                        borderRadius: 6,
                        color: '#1e3a8a',
                        fontSize: 12,
                        fontWeight: 600,
                        cursor: 'pointer',
                    }}
                >
                    <ArrowClockwise size={14} weight="bold" />
                    Refresh / Actualizar
                </button>
            </div>
            <iframe
                key={src}
                title="Macola Scrap Codes"
                src={src}
                style={{
                    width: '100%',
                    flex: 1,
                    border: 0,
                    display: 'block',
                }}
            />
        </div>
    )
}
